import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { useExclusions } from '../../../exclusions/actions/exclusions-actions';
import { onExcludeIssue } from '../actions/issues-exclusions-actions';
import ExcludeIssueModal from '../components/IssueTableRow/ExcludeIssueModal';
import {
  setExclusionIssueComment,
  setSnoozeIssueExpiredDate,
} from '../../active-issues/store-actions/issue-store-actions';
import { setExclusionIssueComment as setExclusionIssueCommentPipeline } from '../../pipeline-issues/store-actions/pipeline-issues-store-actions';
import { setExcludeIssueModal } from '../store-actions/issues-exclusions-store-actions';
import IssuesExclusionsStore from '../stores/issues-exclusions-store';
import IssuesStore from '../../active-issues/stores/issues-store';
import PipelineIssuesStore from '../../pipeline-issues/stores/pipeline-issues-store';

const ExclusionIssueContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { isExcludeAlertLoading } = useExclusions();

  const { selectedIssue } = useSnapshot(IssuesStore);
  const { excludeIssueModal, excludeCategoryName } = useSnapshot(
    IssuesExclusionsStore,
  );
  const { selectedIssue: pipelineSelectedIssue } =
    useSnapshot(PipelineIssuesStore);

  const handleClose = () => {
    setExcludeIssueModal(false);
  };
  return (
    <ExcludeIssueModal
      open={excludeIssueModal}
      onCloseExcludeIssue={handleClose}
      handleExcludeIssue={onExcludeIssue}
      handleSnoozeDateChange={setSnoozeIssueExpiredDate}
      isLoading={isExcludeAlertLoading}
      issueName={
        selectedIssue
          ? selectedIssue.mainTitle
          : pipelineSelectedIssue?.mainTitle
      }
      appName={
        selectedIssue ? selectedIssue.app.name : pipelineSelectedIssue?.app.name
      }
      excludeCategoryName={excludeCategoryName}
      excludeRule={
        selectedIssue ? selectedIssue.ruleId : pipelineSelectedIssue?.ruleId
      }
      excludeComment={
        selectedIssue
          ? selectedIssue.exclusionIssueComment
          : pipelineSelectedIssue?.exclusionIssueComment
      }
      setExcludeComment={
        pipelineSelectedIssue
          ? setExclusionIssueCommentPipeline
          : setExclusionIssueComment
      }
    />
  );
};

export default ExclusionIssueContainer;
